import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00b30f4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "function-navigation" }
const _hoisted_2 = { class: "function-navigation-content" }
const _hoisted_3 = { class: "function-heading" }
const _hoisted_4 = { class: "function-title" }
const _hoisted_5 = { class: "function-description" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 28 24",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "2",
    y: "4",
    width: "17",
    height: "14",
    rx: "3"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M19 8l7-3v12l-7-3M6 18l-2 4m11-4 2 4" }),
  /*#__PURE__*/_createElementVNode("path", { d: "m9 8 5 3-5 3z" })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "帮助视频", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "membership-reminder",
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_FunctionGuideVideo = _resolveComponent("FunctionGuideVideo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "back-icon",
        type: "button",
        "aria-label": "返回上一页",
        title: "返回上一页",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goback && _ctx.goback(...args)))
      }, [
        _createVNode(_component_svg_icon, {
          icon: "prev",
          "aria-hidden": "true"
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.functionTitle), 1),
          _createElementVNode("p", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.functionDescription) + " ", 1),
            (_ctx.functionVideoUrl)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "function-video-button",
                  type: "button",
                  "aria-label": "播放功能演示视频",
                  title: "播放功能演示视频",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.guideVideoVisible = true))
                }, _hoisted_8))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.reminderText)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.reminderText), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_FunctionGuideVideo, {
      visible: _ctx.guideVideoVisible,
      url: _ctx.functionVideoUrl,
      title: _ctx.functionTitle,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.guideVideoVisible = false))
    }, null, 8, ["visible", "url", "title"])
  ], 64))
}